module.exports.default = [
    {
        "name": "Basque",
        "code": "eu",
        "translations": 54,
        "percentage": 32.53,
        "updated": "2021-11-09T07:22:35+0000"
    },
    {
        "name": "Bulgarian",
        "code": "bg",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:40:46+0000"
    },
    {
        "name": "Catalan",
        "code": "ca",
        "translations": 54,
        "percentage": 32.53,
        "updated": "2021-11-09T07:22:46+0000"
    },
    {
        "name": "Danish",
        "code": "da",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:41:35+0000"
    },
    {
        "name": "Dutch",
        "code": "nl",
        "translations": 105,
        "percentage": 63.25,
        "updated": "2021-05-23T09:52:47+0000"
    },
    {
        "name": "English",
        "code": "en",
        "translations": 166,
        "percentage": 100,
        "updated": "2026-01-26T13:10:01+0000"
    },
    {
        "name": "Finnish",
        "code": "fi",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-11-26T12:36:25+0000"
    },
    {
        "name": "French",
        "code": "fr",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-11-26T12:38:07+0000"
    },
    {
        "name": "Galician",
        "code": "gl",
        "translations": 54,
        "percentage": 32.53,
        "updated": "2021-11-09T07:23:00+0000"
    },
    {
        "name": "German",
        "code": "de",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:10:41+0000"
    },
    {
        "name": "Greek",
        "code": "el",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:21:57+0000"
    },
    {
        "name": "Hebrew",
        "code": "he",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:12:41+0000"
    },
    {
        "name": "Italian",
        "code": "it",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:15:06+0000"
    },
    {
        "name": "Kinyarwanda",
        "code": "rw",
        "translations": 148,
        "percentage": 89.16,
        "updated": "2024-03-18T13:50:42+0000"
    },
    {
        "name": "Polish",
        "code": "pl",
        "translations": 27,
        "percentage": 16.27,
        "updated": "2024-03-18T13:51:33+0000"
    },
    {
        "name": "Portuguese",
        "code": "pt",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:16:33+0000"
    },
    {
        "name": "Portuguese (BR)",
        "code": "pt-br",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:17:15+0000"
    },
    {
        "name": "Romanian",
        "code": "ro",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:56:28+0000"
    },
    {
        "name": "Russian",
        "code": "ru",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:57:17+0000"
    },
    {
        "name": "Spanish",
        "code": "es",
        "translations": 161,
        "percentage": 96.99,
        "updated": "2025-12-01T10:19:33+0000"
    },
    {
        "name": "Swedish",
        "code": "sv",
        "translations": 27,
        "percentage": 16.27,
        "updated": "2020-06-04T07:43:55+0000"
    },
    {
        "name": "Thai",
        "code": "th",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:57:53+0000"
    },
    {
        "name": "Turkish",
        "code": "tr",
        "translations": 27,
        "percentage": 16.27,
        "updated": "2020-06-04T07:23:37+0000"
    },
    {
        "name": "Vietnamese",
        "code": "vi",
        "translations": 26,
        "percentage": 15.66,
        "updated": "2020-06-04T07:54:35+0000"
    }
];
	